<template>
	<div
		v-if="loaded"
		class="sal-components-etf-quote-top"
	>
		<sal-components-mip-investment-overview
			:international-request-templates="internationalRequestTemplates"
			class="sal-components-mip-investment-overview__wrapper sal-component"
			hide-quote-header
			mwc-id="salMipInvestmentOverview"
		/>

		<sal-components-etf-quote
			:international-request-templates="internationalRequestTemplates"
			class="sal-components-etf-quote__wrapper sal-component"
			hide-quote-header
			mwc-id="salMipQuote"
			show-full-chart-link
		/>

		<sal-components-mip-analysis
			v-if="canShowMipAnalysis"
			:country-code-filter="countryCodeFilter"
			:enable-investment-preview="false"
			:enable-security-hyperlinks="true"
			class="sal-components-mip-analysis__wrapper sal-component"
			disabled-read-full
			mwc-id="salMipAnalysis"
		/>

		<sal-components-performance
			class="sal-components-performance__wrapper sal-component"
			default-trailing-return-time-period="quarterly"
			mwc-id="salPerformance"
		/>
	</div>
</template>

<script>
import SalComponentsEtfQuote from '@sal/etf-quote';
import SalComponentsMipAnalysis from '@sal/mip-analysis';
import SalComponentsMipInvestmentOverview from '@sal/mip-investment-overview';
import SalComponentsPerformance from '@sal/performance';
import SalCommonMixin from '@/mixins/sal-common';

export default {
	name: 'quote-top',
	components: {
		SalComponentsEtfQuote,
		SalComponentsMipAnalysis,
		SalComponentsMipInvestmentOverview,
		SalComponentsPerformance
	},
	mixins: [SalCommonMixin]
};
</script>
